/* Geo notice: see snippets/sole-geo-notice.liquid for the why.
 *
 * Order matters, cheapest first, so a US visitor costs as little as possible:
 *   suppression (stored choice, referrer, campaign, account pages) → ?geo= override →
 *   country lookup → wait for cookie consent → load CSS → show.
 *
 * Country comes from /browsing_context_suggestions.json, the endpoint Shopify's own Geolocation
 * app uses. It is uncached (no-store) and undocumented, so ANY failure or unexpected shape means
 * "show nothing". This notice must never be the reason a page misbehaves.
 */
(function () {
  'use strict';

  var root = document.getElementById('SoleGeoNotice');
  if (!root) return;

  var KEY = 'sole-geo-notice';
  var DAYS = 30;
  var CONSENT_WAIT_MS = 8000;
  var UTM = 'utm_source=soletreadmills&utm_medium=referral&utm_campaign=geo_notice';

  var params = new URLSearchParams(location.search);
  var override = (params.get('geo') || '').toUpperCase();
  var countries = (root.getAttribute('data-countries') || '')
    .split(',').map(function (c) { return c.trim(); }).filter(Boolean);

  /* Remember choices in localStorage only when the visitor allows preference storage; otherwise
     for this tab session. CA is a strict-consent region in Pandectes, so this matters here. */
  function store() {
    var p = window.Shopify && Shopify.customerPrivacy;
    var allowed = true;
    try { if (p && p.preferencesProcessingAllowed) allowed = !!p.preferencesProcessingAllowed(); } catch (e) {}
    try { return allowed ? window.localStorage : window.sessionStorage; } catch (e) { return null; }
  }
  function remembered() {
    var stores = [];
    try { stores.push(window.localStorage, window.sessionStorage); } catch (e) {}
    for (var i = 0; i < stores.length; i++) {
      try {
        var until = parseInt(stores[i].getItem(KEY), 10);
        if (until && until > Date.now()) return true;
      } catch (e) {}
    }
    return false;
  }
  function remember() {
    var s = store();
    try { if (s) s.setItem(KEY, String(Date.now() + DAYS * 864e5)); } catch (e) {}
  }

  function track(action, extra) {
    var payload = { action: action, page_type: root.getAttribute('data-page-type') || '' };
    for (var k in extra) payload[k] = extra[k];
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('sole_geo_notice', payload);
      }
    } catch (e) {}
  }

  function suppressed() {
    if (override && countries.indexOf(override) !== -1) return false;
    if (override) return true;                                  // ?geo=US etc. forces it off
    if (remembered()) return true;
    if (/^\/account/.test(location.pathname)) return true;
    if (/solefitness\.ca/i.test(document.referrer)) return true;
    var campaign = (params.get('utm_campaign') || '') + ' ' + (params.get('utm_source') || '');
    if (/canad/i.test(campaign)) return true;                   // arrived from a Canadian campaign
    return false;
  }

  /* One lookup per tab session: the answer is cached in sessionStorage, so later page views
     cost nothing. Low fetch priority so it never competes with the page's own images. */
  var COUNTRY_KEY = 'sole-geo-country';
  function country() {
    if (override) return Promise.resolve(override);
    try {
      var cached = window.sessionStorage.getItem(COUNTRY_KEY);
      if (cached) return Promise.resolve(cached);
    } catch (e) {}
    return fetch('/browsing_context_suggestions.json', {
      headers: { Accept: 'application/json' }, credentials: 'same-origin', priority: 'low'
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country;
        var code = c && typeof c.handle === 'string' ? c.handle.toUpperCase() : '';
        if (/^[A-Z]{2}$/.test(code)) { try { window.sessionStorage.setItem(COUNTRY_KEY, code); } catch (e) {} }
        return code;
      })
      .catch(function () { return ''; });
  }

  /* Wait for the Pandectes cookie banner to be answered, so the two never fight for attention or
     focus. Already answered = the _pandectes_gdpr cookie exists. No banner for this visitor =
     shouldShowBanner() is false (Pandectes makes the same call to decide). Ignored = give up after 8s. */
  function noBanner() {
    // Pandectes shows its banner to EVERY visitor (an OK-only notice where shouldShowBanner() is
    // false, an opt-in banner where it is true), so while it is installed only the cookie / event /
    // timeout count. Its inline settings object exists before any of this runs.
    if (window.pandectesBannerSettings || window.PandectesCore || document.querySelector('pandectes-cmp')) return false;
    try {
      var p = window.Shopify && Shopify.customerPrivacy;
      return !!(p && p.shouldShowBanner && p.shouldShowBanner() === false);
    } catch (e) { return false; }
  }
  function consentSettled() {
    if (/(^|;\s*)_pandectes_gdpr=/.test(document.cookie) || noBanner()) return Promise.resolve();
    return new Promise(function (resolve) {
      var done = false, poll;
      function go() { if (!done) { done = true; clearInterval(poll); resolve(); } }
      document.addEventListener('visitorConsentCollected', go, { once: true });
      poll = setInterval(function () { if (noBanner()) go(); }, 250); // privacy API may load after us
      setTimeout(go, CONSENT_WAIT_MS);
    });
  }

  function loadCss() {
    var href = root.getAttribute('data-css');
    if (!href) return Promise.resolve();
    return new Promise(function (resolve) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = link.onerror = function () { resolve(); };
      document.head.appendChild(link);
    });
  }

  function cartHasItems() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { return !!(c && c.item_count > 0); })
      .catch(function () { return false; });
  }

  // Only the full-width mobile strip shares the bottom edge with chat; the desktop card sits
  // bottom-left with chat bottom-right, so it claims nothing there. Breakpoint matches the CSS.
  var mobile = window.matchMedia('(max-width: 749px)');
  var html = document.documentElement;
  var resizeObserver = null, lastOutside = null, liveTimer = null;
  function claim() {
    if (window.SoleSafeBottom && SoleSafeBottom.stack) {
      SoleSafeBottom.stack('geo-notice', root.hidden || !mobile.matches ? 0 : root.offsetHeight);
    }
    // Scroll padding while open (css: html.sole-geo-open), so focus never lands behind the notice.
    if (root.hidden) {
      html.classList.remove('sole-geo-open');
      html.style.removeProperty('--sole-geo-h');
    } else {
      html.style.setProperty('--sole-geo-h', (root.offsetHeight + (mobile.matches ? 0 : 24)) + 'px');
      html.classList.add('sole-geo-open');
    }
  }
  // Remember the last thing focused OUTSIDE the notice, so closing it can hand focus back there.
  function trackFocus(e) { if (!root.contains(e.target)) lastOutside = e.target; }
  if (mobile.addEventListener) mobile.addEventListener('change', claim);

  function hide(method) {
    remember();
    if (method) track(method === 'stay' ? 'stay' : 'dismiss', method === 'stay' ? {} : { method: method });
    var hadFocus = root.contains(document.activeElement);
    root.classList.remove('is-open');
    root.hidden = true;
    if (resizeObserver) resizeObserver.disconnect();
    document.removeEventListener('focusin', trackFocus, true);
    claim();
    var live = document.getElementById('SoleGeoNoticeLive');
    if (live) live.textContent = '';
    clearTimeout(liveTimer);
    if (hadFocus && lastOutside && lastOutside.isConnected && lastOutside !== document.body &&
        lastOutside.getClientRects().length) {
      // Back to where the visitor was before they moved into the notice.
      lastOutside.focus({ preventScroll: true });
    } else if (hadFocus) {
      // Never strand keyboard focus on a removed control: hand it to the main landmark.
      var main = document.getElementById('MainContent');
      if (main) {
        main.setAttribute('tabindex', '-1');
        main.classList.add('sole-geo-focus-target');
        main.addEventListener('blur', function () {
          main.removeAttribute('tabindex');
          main.classList.remove('sole-geo-focus-target');
        }, { once: true });
        main.focus({ preventScroll: true });
      }
    }
  }

  function show(hasItems, countryCode) {
    var go = root.querySelector('[data-geo-go]');
    var href = root.getAttribute('data-href');
    if (go && href) go.href = href + (href.indexOf('?') === -1 ? '?' : '&') + UTM;
    if (hasItems) {
      var note = root.querySelector('[data-geo-cart]');
      if (note) note.hidden = false;
    }

    if (document.activeElement && document.activeElement !== document.body) lastOutside = document.activeElement;
    document.addEventListener('focusin', trackFocus, true);
    root.hidden = false;
    claim();
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(claim);
      resizeObserver.observe(root);
    }
    requestAnimationFrame(function () { root.classList.add('is-open'); });

    // Announce once, politely. Focus is deliberately left where the visitor put it.
    // The text is cleared again afterwards, so it isn't read a second time in browse mode.
    var live = document.getElementById('SoleGeoNoticeLive');
    var parts = root.querySelectorAll('.sole-geo__heading, .sole-geo__body, .sole-geo__cart:not([hidden])');
    if (live) {
      live.textContent = Array.prototype.map.call(parts, function (p) { return p.textContent.trim(); }).join(' ');
      liveTimer = setTimeout(function () { live.textContent = ''; }, 7000);
    }

    if (go) go.addEventListener('click', function () {
      remember();
      track('click', { destination: go.href });
    });
    var stay = root.querySelector('[data-geo-stay]');
    if (stay) stay.addEventListener('click', function () { hide('stay'); });
    var close = root.querySelector('[data-geo-close]');
    if (close) close.addEventListener('click', function () { hide('x'); });

    // Own Esc handler: the Pandectes GDPR app preventDefault()s every Escape storefront-wide.
    // This listener is on the notice itself, so it runs before Pandectes' document listener.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); hide('esc'); }
    });

    track('view', { country: countryCode, forced: !!override });
  }

  function start() {
    if (suppressed()) return;
    country().then(function (c) {
      if (!c || countries.indexOf(c) === -1) return null;
      return consentSettled()
        .then(function () { return Promise.all([loadCss(), cartHasItems()]); })
        .then(function (r) { if (!remembered() || override) show(r[1], c); });
    }).catch(function () {});
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(start, { timeout: 3000 });
  } else {
    setTimeout(start, 1200);
  }
})();
